import { OnEventDispatcher } from "./core/on-event-dispatcher";
import { Application } from "./main";
import { HtmlPartials } from "../../shared/htmlpartials";
import { DelayedCall } from "./core/delayed-call";
import { GADataLayer } from "./io/gadatalayer";
import { loadJson } from "./core/loadjson";

export class ArticlesView extends OnEventDispatcher {

    elm: JQuery<HTMLElement>;

    inner: JQuery<HTMLElement>;
    
    constructor(container:JQuery<HTMLElement>, path:string) {
        super();

        Application.showLoader();

        (async () => {
            let data:{list:any, meta:any} = null;

            

            console.log("contentslug: " + Application.getDataSlug());
            console.log("path: " + path);
            if(Application.getDataSlug()!=path) {
                console.log("Loading data...");
                Application.setDataSlug(path);
                container.html("");
                data = await loadJson(path+"/json");
                this.elm = $(HtmlPartials.getVaxiArticleList(data.meta, data.list)).appendTo(container);
                Application.setTitle("Resevaccin");
            } else {
                console.log("Data already set...");
                this.elm = container.find("> .articles-view");
            }
    
            $(".content")[0].scrollTo(0,0);

            Application.hideLoader();
    
            let allAvailableFilters = this.elm.attr("data-tagscollected")?.split(",")||[];
    
            let updateFilters = () => {
                let activeFilters:Array<string> = [];
                container.find(".tag-filter .tag-filter-item").each((_index:number, helm:HTMLElement) => {
                    let elm = $(helm);
                    if(!elm.hasClass("inactive")) activeFilters.push(elm.attr("data-filter"));
                });
                let showAll = false;
                if(activeFilters.length==allAvailableFilters.length||activeFilters.length==0) {
                    showAll = true;
                }
                this.elm.find(".article-list-item[data-filters]").each((_index:number, helm:HTMLElement) => {
                    if(showAll) {
                        $(helm).show();
                    } else {
                        let show:boolean = false;
                        let filters = $(helm).attr("data-filters")?.split(",");
                        for(let m in filters) {
                            if(activeFilters.includes(filters[m])) show = true;
                        }
                        if(show){
                            $(helm).show();
                        } else {
                            $(helm).hide();
                        }
                    }
                });
            }
            container.find(".tag-filter .tag-filter-item").each((_index:number, helm:HTMLElement) => {
                let elm = $(helm);
                let handleClickDelay:DelayedCall = new DelayedCall(() => {
                    elm.toggleClass("inactive");
                    updateFilters();
                }, 300, false);
                elm.on("click", () => {
                    handleClickDelay.restart();
                });
                elm.on("dblclick", () => {
                    handleClickDelay.cancel();
                    if(elm.hasClass("inactive")) {
                        container.find(".tag-filter .tag-filter-item").removeClass("inactive");
                    } else {
                        container.find(".tag-filter .tag-filter-item").addClass("inactive");
                        elm.removeClass("inactive");
                    }
                    updateFilters();
                });
            });
    
            container.find("a").each((_index:number, helm:HTMLElement) => {
                let elm = $(helm);
                let href:string = elm.attr("href");
                let isInternal:boolean = ((href.indexOf("/")==0&&href.indexOf("//")!=0&&href.indexOf("http")!=0)) || (href.indexOf("#")==0||href.indexOf("javascript:")==0);
                if(!isInternal) {
                    elm.attr("target", "_blank");
                }
                elm.on("click", (e:any) => {
                    GADataLayer.link_click(href, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    if(isInternal && href.indexOf("#")!=0 && href.indexOf("javascript:")!=0) {
                        e.preventDefault();
                        e.stopPropagation();
                        Application.stateManager.setPath(href);
                        return false;
                    }
                });
            });
    
            this.elm.find("*[data-url]").each((_index:number, helm:HTMLElement) => {
                let elm = $(helm);
                elm.on("click", (e:any) => {
                    let href:string = elm.attr("data-url");
                    GADataLayer.link_click(href, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    if(href.indexOf("/")==0&&href.indexOf("//")!=0&&href.indexOf("http")!=0) {
                        e.preventDefault();
                        e.stopPropagation();
                        Application.stateManager.setPath(href);
                        return false;
                    }
                });
            });
        })();

        

        
    }

}